import makeStyles from '@mui/styles/makeStyles'
import { Paper } from '@components'
import { colors } from '@global/constants'

const useStyles = makeStyles(() => ({
  root: {
    height: '100vh',
    display: 'flex',
    backgroundColor: colors.gray.light,
    overflow: 'hidden',
  },
}))

export const MainTabHolder = ({ children }) => {
  const classes = useStyles()

  return <Paper className={classes.root}>{children}</Paper>
}
